import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollspyDirective } from './scrollspy.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CountToModule } from 'angular-count-to';

import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { FooterComponent } from './footer/footer.component';
import { ServicesComponent } from './services/services.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WhoWeAreComponent } from './who-we-are/who-we-are.component';
import { WhyChooseUsComponent } from './why-choose-us/why-choose-us.component';
import { OurClientsComponent } from './our-clients/our-clients.component';
import { AwardsAndRecognitionComponent } from './awards-and-recognition/awards-and-recognition.component';
import { OurTeamComponent } from './our-team/our-team.component';
import { ServiceListComponent } from './service-list/service-list.component';
import { WhyWeAreUniqueComponent } from './why-we-are-unique/why-we-are-unique.component';
import { MainServicesAccordionComponent } from './main-services-accordion/main-services-accordion.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AboutComponent,
    ContactComponent,
    FooterComponent,
    ServicesComponent,
    ScrollspyDirective,
    WhoWeAreComponent,
    WhyChooseUsComponent,
    OurClientsComponent,
    AwardsAndRecognitionComponent,
    OurTeamComponent,
    ServiceListComponent,
    WhyWeAreUniqueComponent,
    MainServicesAccordionComponent,
    NavBarComponent,
  ],
  imports: [
    CommonModule,
    CarouselModule,
    CountToModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollToModule,
    NgbModule,
    RouterModule,
  ],
  exports: [
    AboutComponent,
    ContactComponent,
    FooterComponent,
    ServicesComponent,
    WhoWeAreComponent,
    WhyChooseUsComponent,
    OurClientsComponent,
    AwardsAndRecognitionComponent,
    OurTeamComponent,
    ScrollspyDirective,
    ServiceListComponent,
    WhyWeAreUniqueComponent,
    MainServicesAccordionComponent,
    NavBarComponent,
  ],
})
export class SharedModule {}
